<template>
  <div class="writeDoc content-item flex align-items-center">
    <div class="content-item-label"><span class="red" v-if="JSON.parse(commonData[0].value)==='1'">*</span>{{ JSON.parse(commonData[1].value) }}</div>
    
    <el-select
      v-model="value"
      placeholder="请选择"
      size="mini"
      class="selectBus"
      @change="$emit('petChange', {value: value, list: petClassifyList})"
    >
      <el-option
        v-for="item in petClassifyList"
        :key="item.id"
        :label="item.desc"
        :value="item.code"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { request } from "@/utils/axios";
export default {
  name: "Classify",
  props: ["commonData", "petClassifyCode", "type"],
  data() {
    return {
      petClassifyList: [],
      value:[]
    }
  },
  created() {
    console.log("type",this.type)
    this.queryClassify();
  },
  methods: {
    // 回显数据
    setPetClassifyCheckList (data) {
      this.value = data;
    },
    // 获取分类信息
    queryClassify() {
      let type = null;
      if(this.type == 31) {
        type = [45]
      } else {
        type = [36]
      }
      request("health_cmp_queryDictionaries",{
        typeList: type
      }).then(res => {
        console.log("res>>>>>>",res);
        this.petClassifyList = res || []
      }).catch(err => {
        this.petClassifyList = []
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.red{
  color: #f62458;
	margin-right: 5px;
}

</style>
